module.exports = __webpack_public_path__ + "img/card-reverse_position-guide.820ef1ec.png";